import React from 'react';
import {useParams} from 'react-router-dom';
import {ModuleEnum, PermissionOperationEnum} from 'src/api/ProactApiClient';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import {routeRegistry} from 'src/pages/RouteRegistry';

import {assetDocumentTitle} from 'src/pages/Modules/Assets/assetHelpers';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import type {AssetsViewType} from 'src/shared/constants/ViewTypes';
import {AssetsForm} from 'src/pages/Modules/Assets/shared/AssetForm/AssetForm';
import {AssetsBrowserShell} from 'src/app/assets/AssetsBrowserShell';
import {toAssetTreeNodeId} from 'src/app/assets/assetTreeBrowserState';
import {useGetAssetQuery} from 'src/redux/queries/asset';

const ViewAssetPage: React.FC = () => {
  useSetDocumentTitle(assetDocumentTitle);
  const {assetId, view} = useParams();
  const {data: asset} = useGetAssetQuery(+assetId!, {skip: !assetId});

  return (
    <AssetsBrowserShell
      selectedId={asset ? toAssetTreeNodeId(asset.id) : undefined}>
      <AssetsForm mode="view" id={+assetId!} view={view as AssetsViewType} />
    </AssetsBrowserShell>
  );
};

export default ViewAssetPage;

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.AssetView(':assetId', ':view'),
  element: <ViewAssetPage />,
  module: ModuleEnum.Assets,
  operation: PermissionOperationEnum.View,
  isPrivate: true,
});
